
import { auth } from '../utils/firebase';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001').replace(/\/$/, '');

// Helper to determine auth headers
const getAuthHeaders = async (): Promise<Record<string, string>> => {
    const user = auth.currentUser;
    if (!user) return {};
    try {
        const token = await user.getIdToken();
        return { 'Authorization': `Bearer ${token}` };
    } catch (error) {
        console.error("Error getting auth token:", error);
        return {};
    }
};

export const createPlan = async (payload: any): Promise<any> => {
    const authHeaders = await getAuthHeaders();

    const response = await fetch(`${API_BASE_URL}/api/plan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeaders
        },
        body: JSON.stringify(payload)
    });

    const contentType = response.headers.get('content-type');

    // Critical Check: Ensure we got JSON back
    if (!contentType || !contentType.includes('application/json')) {
        // If we got HTML (likely a 404 page or SPA redirect), we must not parse it as JSON
        const text = await response.text();
        console.error('Expected JSON but got:', contentType, text.substring(0, 200));
        throw new Error('Sunucuya erişilemiyor veya geçersiz bir yanıt alındı. (HTML response)');
    }

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || `Bir hata oluştu: ${response.status}`);
    }

    return data;
};
